import React from 'react';
import { graphql } from 'react-apollo';
import ARTIST_USERS_STATS_QUERY from '../../../../graphql/ArtistUsers';
import LabelValueStats from '../../../../components/LabelValueStats';

const Users = props => (
  <LabelValueStats
    sectionTitle="Usuarios que han visitado tu teatro"
    title="Usuario"
    list={props.stats}
  />
);

const withUsersStats = graphql(ARTIST_USERS_STATS_QUERY, {
  options: () => ({
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    stats: data.getArtistUsers ? data.getArtistUsers.map(i => ({
      label: i.name,
      value: i.count,
    })) : [],
  }),
});

export default withUsersStats(Users);



// WEBPACK FOOTER //
// ./src/containers/Artist/Analytics/Artist/users.js